import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../NoData";
import ChartLoader from '../ChartLoader';
import CommanBarTable_Orion from "./CommanBarTable_Orion";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../DashboardMain_Orion/WaterMark";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
import NoTableData from "./NoTableData";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

function Dcdc_Orion({ gloablfilter, itemSelected, modalName }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("DC-DC");
  const [barcolor, SetBarcolor] = useState("#83A4CF");
  const [yAxisTitle, SetyAxisTitle] = useState("");
  const [box_one, setBox_one] = useState(0)
  const [box_two, setBox_two] = useState(0)
  const [tableData, SetTableData] = useState([]);

  const responceData = async (data) => {
    setBox_one(0)
    setBox_two(0)
    SetTableData([])
    
    res_result = []
    res_result = data;
    let responce = {
      "<40": 0,
      "50": 0,
      "60": 0,
      "70": 0,
      "80": 0,
      "90": 0,
      "100": 0,
      "110": 0,
      "120": 0,
      ">=120": 0,
    };

    let dataCons_kWh = 0, distanceInKM = 0, dynamic_itemSelected = 0
    let vehicle_registration_number = "", Depot_Name = "", DLR_ORG_CITY = ""
    if (res_result.length !== 0) {
      let temp_result = res_result;
      SetApiResponce(res_result)
      temp_result.map((d, index) => {
        let value = d.Energy_Regenarated.value;
        dataCons_kWh = dataCons_kWh + d.dataCons_kWh.value;
        distanceInKM = distanceInKM + d.distanceInKM.value;
        dynamic_itemSelected = dynamic_itemSelected + d[itemSelected].value; //dynamic column

        vehicle_registration_number = d.key.vehicle_registration_number
        Depot_Name = d.key.Depot_Name
        DLR_ORG_CITY = d.key.DLR_ORG_CITY

        if (value != null) {
          if (value >= 0 && value < 40) {
            responce["<40"] = responce["<40"] + 1;
          } else if (value >= 40 && value < 50) {
            responce["50"] = responce["50"] + 1;
          } else if (value >= 50 && value < 60) {
            responce["60"] = responce["60"] + 1;
          } else if (value >= 60 && value < 70) {
            responce["70"] = responce["70"] + 1;
          } else if (value >= 70 && value < 80) {
            responce["80"] = responce["80"] + 1;
          } else if (value >= 80 && value < 90) {
            responce["90"] = responce["90"] + 1;
          } else if (value >= 90 && value < 100) {
            responce["100"] = responce["100"] + 1;
          } else if (value >= 100 && value < 110) {
            responce["110"] = responce["110"] + 1;
          } else if (value >= 110 && value < 120) {
            responce["120"] = responce["120"] + 1;
          } else if (value >= 120) {
            responce[">=120"] = responce[">=120"] + 1;
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      const loop_keys = ["<40", "50", "60", "70", "80", "90", "100", "110", "120", ">=120"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<40", "50", "60", "70", "80", "90", "100", "110", "120", ">=120"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Energy Consumption (Wh/km)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };

      let kpi_one = dynamic_itemSelected / dataCons_kWh * 100
      setBox_one(kpi_one)
      let kpi_two = dynamic_itemSelected / distanceInKM * 1000
      setBox_two(kpi_two)

      if (gloablfilter.VIN_NUM.length === 1) {
        SetTableData([{
          "key": {
            "vehicleId": gloablfilter.VIN_NUM[0],
            "vehicle_registration_number":vehicle_registration_number,
            "Depot_Name":Depot_Name,
            "DLR_ORG_CITY":DLR_ORG_CITY,
          },
          "Energy_Regenarated": {
            "value": kpi_two
          }
        }])
      } else {
        res_result.sort((a, b) => b.Energy_Regenarated.value - a.Energy_Regenarated.value)
        SetTableData(res_result)
      }

      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Energy Consumption (Wh/km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: yAxisTitle,
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: barcolor },
    },
  };

  useEffect(() => {
    if (gloablfilter.VIN_NUM.length === 1) {
      SetBarcolor("#3578b0")
      SetyAxisTitle("No. of Cycles")
      fetchData({ url: API_URL_MAIN + "orion_energy_analytics/kpi_histogram_table_vehicle", body: { filterdata: gloablfilter, itemSelected: itemSelected } }, responceData)
    } else {
      SetBarcolor("#83A4CF")
      SetyAxisTitle("No. of Vehicles")
      fetchData({ url: API_URL_MAIN + "orion_energy_analytics/kpi_histogram_table", body: { filterdata: gloablfilter, itemSelected: itemSelected } }, responceData)
    }
  }, [gloablfilter, itemSelected])

  const [TBText, setTBText] = useState("Top")
  const changeTB = (selectOp) => {
    setTBText(selectOp)
    const reversed = tableData.reverse();
    SetTableData(reversed)
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-7' : 'col-md-4')}>
        <div className="row row_margin_top">
          <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-6 text-right pr-0" : "col-md-6 text-center pr-0" )}>
            <h3 className="mb-0 to_stick">
            {(loggedInUser.flagForHideShow === "ERC") ?
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>Consumption Fraction</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_one.toFixed(2)} %</span></span>
              </>
              :
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>Cons. Fraction</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_one.toFixed(2)} %</span></span>
              </>
            }
              {/* <span className="mb-0" style={{ fontSize: "small" }}>Consumption Fraction</span>
              <span className="badge" style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className="badge-text">{box_one.toFixed(2)} %</span></span> */}
            </h3>
          </div>

          <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-6 text-left" : "col-md-6 text-center" )}>
            <h3 className="mb-0 to_stick">
            {(loggedInUser.flagForHideShow === "ERC") ? 
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>&nbsp;Consumption Factor</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_two.toFixed(2)} Wh/km</span></span>
              </> 
              : 
              <>
                <span className="mb-0" style={{ fontSize: "small" }}>&nbsp;Cons. Factor</span>
                <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_two.toFixed(2)} Wh/km</span></span>
              </>
            }
              {/* <span className="mb-0" style={{ fontSize: "small" }}>&nbsp;Consumption Factor</span>
              <span className={(loggedInUser.flagForHideShow === "ERC" ? "badge" : "badgefleet")} style={{ backgroundColor: (gloablfilter.VIN_NUM.length === 1) ? "#3578b0" : "#83A4CF" }}><span className={(loggedInUser.flagForHideShow === "ERC" ?"badge-text" :"badge-text-fleet" )}>{box_two.toFixed(2)} Wh/km</span></span> */}
            </h3>
          </div>
        </div>

        <WaterMark />
        {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection?.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;

                let filtered_temp = [];
                if (count !== 0) {
                  filtered_temp = apiresponce.filter(x => {
                    if (x.Energy_Regenarated.value <= barvalue && x.Energy_Regenarated.value > barvalue - 10) {
                      return x;
                    }
                    else if (x.Energy_Regenarated.value > 120 && barvalue === ">=120") {
                      return x
                    }
                    else if (x.Energy_Regenarated.value <= 40 && barvalue === "<40") {
                      return x
                    }
                  })

                  function compareObjects(object1, object2, key) {
                    let obj1 = 0
                    let obj2 = 0
                    obj1 = object1.Energy_Regenarated.value
                    obj2 = object2.Energy_Regenarated.value
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'value')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + modalName).modal('show');
                }
              }
            }
          }
        ]}
        /> : <NoData />)}

        <div className="modal fade" id={"exampleModal__" + modalName} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <CommanBarTable_Orion data={filteredData} tabDataKey={"Energy_Regenarated"} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-5' : 'col-md-8')}>
        <div className="row mb-2 d-flex justify-content-end">
          {
            (gloablfilter.VIN_NUM.length !== 1) &&
            <>
              <div className="col-md-6"></div>
              <div className="col-md-6 d-flex justify-content-end">
                <div className="dropdownSelectBtnEnergy_Bus">
                  <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTB(event.target.value)} value={TBText}>
                    <option value="top">Top 10</option>
                    <option value="bottom">Bottom 10</option>
                  </select>
                </div>
              </div>
            </>
          }
        </div>

        <div className="tableContent_Bus px-2 row" style={{ overflowY: 'scroll', height: '225px' }}>
          <WaterMark />
          <table className="table table-striped">
            <thead className="histo_table_th">
              <tr>
                <th scope="col">Vin</th>
                {(loggedInUser.flagForHideShow === 'FLEETEV') &&
                <>
                <th scope="col">Reg. No.</th>
                <th scope="col">City</th>
                <th scope="col">Depo</th>
                </>
                }
                <th scope="col">CF</th>
              </tr>
            </thead>

            <tbody className="histo_table_tb">
              {(tableData.length == 0) ? <NoTableData /> : tableData.slice(0, 10).map((x, index) => {
                return (<tr key={x.key.vehicleId + "_" + index}>
                  <td scope="row">{x.key.vehicleId}</td>
                  {(loggedInUser.flagForHideShow === 'FLEETEV') &&
                  <>
                  <td>{(x.key.vehicle_registration_number)}</td>
                  <td>{(x.key.DLR_ORG_CITY)}</td>
                  <td>{(x.key.Depot_Name)}</td>
                  </>
                  }
                  <td>{(x.Energy_Regenarated.value).toFixed(2)}</td>
                </tr>)
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Dcdc_Orion;